var map = {
	"./ledmac_tagline.svg": 194,
	"./logo_ibi.png": 195,
	"./logo_pwl.png": 196,
	"./logo_themill.png": 197,
	"./projects/01_escala-burnaby.jpg": 60,
	"./projects/02_aviara-burnaby.jpg": 61,
	"./projects/03_reflections-burnaby.jpg": 62,
	"./projects/04_waterscapes-kelowna.jpg": 63,
	"./projects/05_highpoint-coquitlam.jpg": 64,
	"./projects/06_icon-burnaby.jpg": 65,
	"./projects/07_sydney-coquitlam.jpg": 59,
	"./projects/08_azure-burnaby.jpg": 66,
	"./projects/09_northgate_village-burnaby.jpg": 67,
	"./projects/10_perspectives-burnaby.jpg": 68,
	"./projects/11_saltaire-white_rock.jpg": 69,
	"./projects/12_dominion-new_westminster.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 540;